import { gql } from '@apollo/client';

export const GET_WAREHOUSE_LIST_BY_HUB_ID = gql`
    query GetWarehouseListByHubId($hubId: Long!) {
        warehouseList: getWarehouseListByHubId(hubId: $hubId) {
            id
            name
            sortingCode
            siteType
        }
    }
`;

export interface WarehouseType {
    id: string;
    name: string;
    sortingCode?: string;
    siteType: number;
}

export interface GetWarehouseListByHubIdResponse {
    warehouseList: WarehouseType[];
} 